import logo from '../components/Logo';

export const PLATFORM_NAME = 'Team Fenix';
export const Logo = logo;